import React, { useContext } from 'react';

import { GridRowParams, GridValueFormatterParams } from '@mui/x-data-grid';

import CustomDataGrid from '../../components/data-grid';
import { AppContext } from '../../contexts/app-context';
import GlobalStyles from '../../global-styles';
import { formatDateForDataGrid, goToRoutePage } from '../../utils/helper';
import { Box } from '../../utils/material-ui-core';

const ProgramList = () => {
  const globalStyles = GlobalStyles();

  const { writeLog, programs } = useContext(AppContext);

  const columns = [
    { field: "programCode", headerName: "Program Code", width: 190 },
    { field: "programName", headerName: "Program Name", width: 250 },
    { field: "parentName", headerName: "Client Company Name", width: 250 },
    {
      field: "meshifyDomainName",
      headerName: "Domain Name",
      width: 250,
      hide: true,
    },
    {
      field: "routingName",
      headerName: "Routing Name",
      width: 250,
      hide: true,
    },
    {
      field: "showAgreementConfirmation",
      headerName: "Show Agreement Confirmation",
      width: 275,
      hide: true,
    },
    {
      field: "maxAccountCanBeRegister",
      headerName: "Max Account Can Be Register",
      width: 275,
      hide: true,
    },
    {
      field: "defaultPackageId",
      headerName: "Default Package",
      width: 180,
      hide: true,
    },
    { field: "folderId", headerName: "Folder Id", width: 120, hide: true },
    {
      field: "totalPilotAccountForRegistration",
      headerName: "Total Pilot Account For Registration",
      width: 270,
      hide: true,
    },
    {
      field: "shopifyLandingPage",
      headerName: "Shopify Landing Page",
      width: 250,
      hide: true,
    },
    {
      field: "sendToPSFIN",
      headerName: "Send To PS Fin",
      width: 210,
      hide: true,
    },
    {
      field: "managedByDCXTeam",
      headerName: "Enlistment by AEM",
      width: 230,
      hide: true,
    },
    { field: "aemSiteId", headerName: "AEM Site Id", width: 450, hide: true },
    {
      field: "addressline1",
      headerName: "Address Line 1",
      width: 200,
      hide: true,
    },
    {
      field: "addressline2",
      headerName: "Address Line 2",
      width: 200,
      hide: true,
    },
    { field: "locality1", headerName: "Locality 1", width: 150, hide: true },
    { field: "region1", headerName: "Region 1", width: 150, hide: true },
    { field: "postalCode", headerName: "Postal Code", width: 150, hide: true },
    { field: "country", headerName: "Country", width: 150 },
    { field: "active", headerName: "Active", width: 130, type: "boolean" },
    {
      field: "taxExempt",
      headerName: "Tax Exempt",
      width: 150,
      hide: true,
      type: "boolean",
    },
    {
      field: "enrollmentCount",
      headerName: "# Enrolled",
      width: 150,
      type: "number",
      hide: false,
    },
    {
      field: "whiskerGroupType",
      headerName: "Whisker Group Type",
      width: 220,
      hide: true,
    },
    {
      field: "whiskerGroupId",
      headerName: "Whisker Group Id",
      width: 220,
      type: "number",
      hide: true,
    },
    {
      field: "lastModifiedBy",
      headerName: "Last Modified By",
      width: 250,
      hide: true,
    },
    {
      field: "lastModifiedDateTime",
      headerName: "Last Modified Date",
      width: 200,
      type: "dateTime",
      hide: false,
      valueFormatter: (params: GridValueFormatterParams) => formatDateForDataGrid(params.value as string),
    },
    { field: "programKey", headerName: "Program Key", width: 350, hide: true },
  ];

  const handleDataGridClick = (params: GridRowParams, event: any) => {
    const path = "onboarding/programs/" + params.row.programKey;
    writeLog("Onboarding Page", "Opening program detail.", params.row.programKey, "program");
    goToRoutePage(path);
  };

  const getData = () => {
    const rows: any = [];
    programs.map((program, index) => rows.push({ id: index, ...program, ...program.address }));
    return rows;
  };

  return (
    <Box className={globalStyles.onboardingDatagridContainer}>
      <CustomDataGrid uniqueGridCode={"ProgramListResult"} columns={columns} rows={getData()} showToolBar={true} sortModel={[{ field: "programName", sort: "asc" }]} handleDataGridClick={handleDataGridClick} />
    </Box>
  );
};

export default ProgramList;
